<div
    *ngFor="let match of formattedMatches; trackBy: trackByIndex"
>
    <match-display-wrapper
        matchLabel="{{ l10nKeys.geoMatchLabel | vtranslate }}"
        matchCriteria="{{ match.criteria }}"
        subheader="{{ match.attribute }}"
    >
        <div>{{ match.value }}</div>
    </match-display-wrapper>
</div>
